import React from 'react';
import styles from './Spinner.module.scss';

interface SpinnerI {
  isVisible: boolean,
  isMask?: boolean,
  defaultSpinner?: boolean,
  small?: boolean,
}

const Spinner: React.FC<SpinnerI> = ({ isVisible, isMask = false, defaultSpinner = true, small = false }) => {
  const visibleClass = isVisible ? styles.Visible : '';
  const defaultClass = defaultSpinner ? styles.DefaultSpinner : '';
  const smallClass = small ? styles.Small : '';

  let spinner = (
    <div data-testid="global-spinner" className={`spinner ${styles.Spinner} ${defaultClass} ${visibleClass} ${smallClass} `}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );

  if (isMask) {
    spinner = <div className={styles.Mask}>{spinner}</div>;
  }

  return spinner;
};

export default Spinner;
